export default {
  authConnections: [],
  references: {},
  userVisibleColumns: [],
  status: {},
};